import React, { useEffect } from 'react'
import Header from '../shared/Header';
import { Outlet } from 'react-router-dom';
import AllowedRoutes from '../shared/AllowedRoutes'
import { useDispatch, useSelector } from "react-redux";
import {
  SetShowsideNav
} from "../redux/counterSlice";
function Home() {
  const dispatch = useDispatch();
  const showSidenav =  useSelector((state) => state.Head.showSideNav)
  const [isOnline, setIsOnline] = React.useState(navigator.onLine);
  useEffect(() => {
    // Define event listeners
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Attach event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup event listeners on component unmount
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  return (
    <div>
      <div className='main-wrapper'>
          <Header></Header>
          {!isOnline && (
          <div className="bg-blue-400 text-white font-bold text-center py-2 text-xl">
            You are currently offline. Please check your internet connection.
          </div>
        )}
        <section className={`app-body ${!showSidenav ? 'fullOutlet' : ""}`}>
        <AllowedRoutes/>
          <div className={`outlet-body`}>
            <Outlet />
            {!showSidenav && <div className={'overlay mobileOverlay'} onClick={()=>{ dispatch(SetShowsideNav(!showSidenav))}}>

            </div>}
            {/* <Home></Home> */}
            {/* <AddAdvertiser></AddAdvertiser> */}
            {/* <AddCreative></AddCreative> */}
            {/* <CreativewiseReport></CreativewiseReport> */}
            {/* <Targeting></Targeting> */}
          </div>
        </section>
      </div>
    </div>
  )
}

export default Home
